import { Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/* eslint-disable @angular-eslint/directive-class-suffix */
@Directive({
    selector: 'input[type=file]',
    host: {
        '(change)': 'onChange()', // eslint-disable-line @typescript-eslint/naming-convention
        '(blur)': 'onTouched()' // eslint-disable-line @typescript-eslint/naming-convention
    },
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: ApFileValueAccessor, multi: true }]
})
export class ApFileValueAccessor implements ControlValueAccessor {
    // https://stackoverflow.com/questions/41889384/angular2-validation-for-input-type-file-wont-trigger-when-changing-the-fi/41938495#41938495
    public value: any;
    public onChange = () => {};
    public onTouched = () => {};
    public writeValue(): void {}

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
